module.exports = __webpack_public_path__ + "img/activate-6-catch-up.cf09882.png";